import * as React from 'react';
// import Draggable from 'react-draggable';
// import { Icon as AntdIcon } from 'antd';
// import {
//   // Renderer,
//   RendererComponentProps
//   // ContextObserver
// } from '../../../../webana';
// import { observer } from 'mobx-react';
// import { Subscriber } from 'react-broadcast';

// interface IconConfig {
//   type: string;
//   spin?: boolean;
// }

// @observer
// export class IconComponent extends React.Component<
//   RendererComponentProps<IconConfig> & ContextObserver<any>
// > {
//   render() {
//     const { type, spin } = this.props.config;
//     return <AntdIcon type={type} spin={spin} />;
//   }
// }

export class BlahDrag extends React.Component {
  // <
  //   RendererComponentProps<IconConfig>
  // >
  render() {
    return (
      // <Draggable>
      <div>aaa</div>
      // </Draggable>
    );
  }
}

// // Let's make <Card text='Write the docs' /> draggable!

// import * as React from 'react';
// // import PropTypes from 'prop-types';
// // import {
// //   DragSource,
// //   ConnectDragSource,
// //   DragSourceConnector,
// //   DragSourceMonitor,
// //   DragSourceSpec
// // } from 'react-dnd';

// // interface NodeProps {
// //   label?: string;
// //   position: {};
// // }

// /* New node from the node well */
// // export interface NodeSourceProps {
// //   isDragging: boolean;
// //   connectDragSource: ConnectDragSource;
// // }
// // export interface NodeSourceState {}

// // // Spec: drag events to handle.
// // let nodeSourceSpec = {
// //   beginDrag: props => ({})
// // };

// // // Collect: Put drag state into props
// // let nodeSourceCollector = (connect, monitor) => {
// //   return {
// //     connectDragSource: connect.dragSource(),
// //     isDragging: monitor.isDragging()
// //   };
// // };

// // // @DragSource('new-node', nodeSourceSpec, nodeSourceCollector)
// // export class DragSourceComponent extends React.Component {
// //   // constructor(props) {
// //   //   super(props);
// //   // }
// //   render() {
// //     return <span>aaaa </span>;
// //     // const { connectDragSource, isDragging } = this.props;
// //     // console.log(isDragging);
// //     // return connectDragSource(<span className="node-source">{'\u2683'}</span>);
// //   }
// // }

// export class BlahDrag extends React.Component {
//   render() {
//     return 'aaa';
//   }
// }
// // /**
// //  * Implements the drag source contract.
// //  */
// // const cardSource = {
// //   beginDrag(props: any) {
// //     return {
// //       text: props.text
// //     };
// //   }
// // };
// // let nodeSourceSpec: DragSourceSpec<NodeSourceProps> = {
// //   beginDrag: (props: NodeSourceProps) => ({})
// // };

// // export interface NodeSourceProps {
// //   isDragging: boolean;
// //   connectDragSource?: ConnectDragSource;
// // }
// // export interface NodeSourceState {}

// // @DragSource(
// //   'card-type',
// //   nodeSourceSpec,
// //   (connect: DragSourceConnector, monitor: DragSourceMonitor) => ({
// //     connectDragSource: connect.dragSource(),
// //     isDragging: monitor.isDragging()
// //   })
// // )
// // export default class Card extends React.Component<
// //   NodeSourceProps,
// //   NodeSourceState
// // > {
// //   //   static propTypes = {
// //   //     text: PropTypes.string.isRequired,

// //   //     // Injected by React DnD:
// //   //     connectDragSource: PropTypes.func.isRequired,
// //   //     isDragging: PropTypes.bool.isRequired
// //   //   };

// //   constructor(props: NodeSourceProps) {
// //     super(props);
// //   }

// //   render() {
// //     const { isDragging, connectDragSource } = this.props;
// //     return connectDragSource(
// //       <div style={{ opacity: isDragging ? 0.5 : 1 }}>aaaaa</div>
// //     );
// //   }
// // }



// WEBPACK FOOTER //
// ./src/modules/calendar/components/dragndrop/DragSource.tsx